var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingiconsmainactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.9992H4V6.35922C4.00003 6.04436 4.09914 5.73749 4.28328 5.48209C4.46743 5.22669 4.72727 5.03572 5.026 4.93622L13.026 2.27022C13.2515 2.19513 13.4915 2.17468 13.7264 2.21055C13.9614 2.24643 14.1844 2.3376 14.3772 2.47656C14.5699 2.61552 14.7269 2.7983 14.8352 3.00983C14.9435 3.22135 15 3.45559 15 3.69322V18.9992H16V9.98922C16 9.91528 16.0165 9.84226 16.0482 9.77544C16.0798 9.70861 16.1259 9.64964 16.1831 9.60277C16.2403 9.55591 16.3072 9.52231 16.3789 9.5044C16.4507 9.4865 16.5255 9.48473 16.598 9.49922L18.794 9.93922C19.1339 10.0072 19.4398 10.1907 19.6597 10.4587C19.8795 10.7267 19.9998 11.0626 20 11.4092V18.9992H21C21.2652 18.9992 21.5196 19.1046 21.7071 19.2921C21.8946 19.4796 22 19.734 22 19.9992C22 20.2644 21.8946 20.5188 21.7071 20.7063C21.5196 20.8939 21.2652 20.9992 21 20.9992H3C2.73478 20.9992 2.48043 20.8939 2.29289 20.7063C2.10536 20.5188 2 20.2644 2 19.9992C2 19.734 2.10536 19.4796 2.29289 19.2921C2.48043 19.1046 2.73478 18.9992 3 18.9992Z",
    fill: "#5070DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingiconsmainactive);
export default __webpack_public_path__ + "static/media/buildingiconsmainactive.ab20836f7015ec4ae2faa616df65f0bf.svg";
export { ForwardRef as ReactComponent };